import { useGenericPermissions } from '@infuse/iam/permission/queries';
import { searchTenantPermissions } from '@infuse/api/iam/tenant';

export const useTenantPermissions = () => {
  return useGenericPermissions({
    apiFn: searchTenantPermissions,
    queryKeys: ['permissions', 'tenant'],
    onlyEnableWithParentId: true
  });
};
